import { put } from 'redux-saga/effects';

import * as AnalyticsHelpers from './helpers';

export function* onLogEvent({ payload: { eventType, eventName, eventData } }) {
  yield* AnalyticsHelpers.getLoggingActions(eventType, eventName).map(loggingAction =>
    put(loggingAction(eventData)),
  );
}
